// extracted by mini-css-extract-plugin
module.exports = {"searchField":"_25hdI","brandsList":"_26U8f","mt20":"_1D3ng","loadingIcon":"_2-WB4"};